import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import LearningUnit09 from "../assets/json/learning_unit_09.json";
import LearningUnit10 from "../assets/json/learning_unit_10.json";
import LearningUnit11 from "../assets/json/learning_unit_11.json";
import LearningUnit12 from "../assets/json/learning_unit_12.json";
import LearningUnit13 from "../assets/json/learning_unit_13.json";
import LearningUnit14 from "../assets/json/learning_unit_14.json";
import LearningUnit15 from "../assets/json/learning_unit_15.json";
import LearningUnit16 from "../assets/json/learning_unit_16.json";
import LearningUnit17 from "../assets/json/learning_unit_17.json";
import LearningUnit18 from "../assets/json/learning_unit_18.json";
import LearningUnit19 from "../assets/json/learning_unit_19.json";
import LearningUnit20 from "../assets/json/learning_unit_20.json";
import LearningUnit21 from "../assets/json/learning_unit_21.json";
import LearningUnit22 from "../assets/json/learning_unit_22.json";
import LearningUnit23 from "../assets/json/learning_unit_23.json";
import LearningUnit24 from "../assets/json/learning_unit_24.json";
import LearningUnit25 from "../assets/json/learning_unit_25.json";
import LearningUnit26 from "../assets/json/learning_unit_26.json";
import LearningUnit27 from "../assets/json/learning_unit_27.json";
import LearningUnit28 from "../assets/json/learning_unit_28.json";
import LearningUnit29 from "../assets/json/learning_unit_29.json";
import LearningUnit30 from "../assets/json/learning_unit_30.json";
import LearningUnit31 from "../assets/json/learning_unit_31.json";
import LearningUnit32 from "../assets/json/learning_unit_32.json";
import LearningUnit33 from "../assets/json/learning_unit_33.json";
import LearningUnit34 from "../assets/json/learning_unit_34.json";
import LearningUnit35 from "../assets/json/learning_unit_35.json";
import LearningUnit36 from "../assets/json/learning_unit_36.json";
import LearningUnit37 from "../assets/json/learning_unit_37.json";
import LearningUnit38 from "../assets/json/learning_unit_38.json";
import LearningUnit39 from "../assets/json/learning_unit_39.json";
import LearningUnit40 from "../assets/json/learning_unit_40.json";
import LearningUnit41 from "../assets/json/learning_unit_41.json";
import LearningUnit42 from "../assets/json/learning_unit_42.json";
import LearningUnit43 from "../assets/json/learning_unit_43.json";
import LearningUnit44 from "../assets/json/learning_unit_44.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;


const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "新編 新しい国語 ５ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "「言葉の力」を集めよう" },
    props: {
      unitTitle: unit_titles[0].title,
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "デジタルノートの作り方" },
    props: {
      unitTitle: unit_titles[1].title,
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "おにぎり石の伝説" },
    props: {
      unitTitle: unit_titles[2].title,
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう１" },
    props: {
      unitTitle: unit_titles[3].title,
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "図書館へ行こう" },
    props: {
      unitTitle: unit_titles[4].title,
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "知りたいことを聞き出そう" },
    props: {
      unitTitle: unit_titles[5].title,
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "敬語" },
    props: {
      unitTitle: unit_titles[6].title,
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "インターネットは冒険だ" },
    props: {
      unitTitle: unit_titles[7].title,
      learningUnitJson: LearningUnit08,
    },
  },
  {
    path: "/i/",
    name: "i",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう２" },
    props: {
      unitTitle: unit_titles[8].title,
      learningUnitJson: LearningUnit09,
    },
  },
  {
    path: "/j/",
    name: "j",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "地域のみりょくを伝えよう" },
    props: {
      unitTitle: unit_titles[9].title,
      learningUnitJson: LearningUnit10,
    },

  },
  {
    path: "/k/",
    name: "k",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字の成り立ち" },
    props: {
      unitTitle: unit_titles[10].title,
      learningUnitJson: LearningUnit11,
    },

  },
  {
    path: "/l/",
    name: "l",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "いにしえの言葉に親しもう" },
    props: {
      unitTitle: unit_titles[11].title,
      learningUnitJson: LearningUnit12,
    },

  },
  {
    path: "/m/",
    name: "m",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "世界でいちばんやかましい音" },
    props: {
      unitTitle: unit_titles[12].title,
      learningUnitJson: LearningUnit13,
    },

  },
  {
    path: "/n/",
    name: "n",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう３" },
    props: {
      unitTitle: unit_titles[13].title,
      learningUnitJson: LearningUnit14,
    },

  },
  {
    path: "/o/",
    name: "o",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "思考に関わる言葉" },
    props: {
      unitTitle: unit_titles[14].title,
      learningUnitJson: LearningUnit15,
    },

  },
  {
    path: "/p/",
    name: "p",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "新聞記事を読み比べよう" },
    props: {
      unitTitle: unit_titles[15].title,
      learningUnitJson: LearningUnit16,
    },

  },
  {
    path: "/q/",
    name: "q",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "五年生の本だな" },
    props: {
      unitTitle: unit_titles[16].title,
      learningUnitJson: LearningUnit17,
    },

  },
  {
    path: "/r/",
    name: "r",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "心の動きを短歌で表そう" },
    props: {
      unitTitle: unit_titles[17].title,
      learningUnitJson: LearningUnit18,
    },

  },
  {
    path: "/s/",
    name: "s",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "問題を解決するために話し合おう" },
    props: {
      unitTitle: unit_titles[18].title,
      learningUnitJson: LearningUnit19,
    },

  },
  {
    path: "/t/",
    name: "t",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう４" },
    props: {
      unitTitle: unit_titles[19].title,
      learningUnitJson: LearningUnit20,
    },

  },
  {
    path: "/u/",
    name: "u",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "注文の多い料理店" },
    props: {
      unitTitle: unit_titles[20].title,
      learningUnitJson: LearningUnit21,
    },

  },
  {
    path: "/v/",
    name: "v",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう５" },
    props: {
      unitTitle: unit_titles[21].title,
      learningUnitJson: LearningUnit22,
    },

  },
  {
    path: "/w/",
    name: "w",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "どうやって文をつなげればいいの？" },
    props: {
      unitTitle: unit_titles[22].title,
      learningUnitJson: LearningUnit23,
    },

  },
  {
    path: "/x/",
    name: "x",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "和の文化を受けつぐ" },
    props: {
      unitTitle: unit_titles[23].title,
      learningUnitJson: LearningUnit24,
    },

  },
  {
    path: "/y/",
    name: "y",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "和の文化を発信しよう" },
    props: {
      unitTitle: unit_titles[24].title,
      learningUnitJson: LearningUnit25,
    },

  },
  {
    path: "/z/",
    name: "z",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "熟語の構成と意味" },
    props: {
      unitTitle: unit_titles[25].title,
      learningUnitJson: LearningUnit26,
    },

  },
  {
    path: "/0/",
    name: "0",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "提案します、一週間チャレンジ" },
    props: {
      unitTitle: unit_titles[26].title,
      learningUnitJson: LearningUnit27,
    },

  },
  {
    path: "/1/",
    name: "1",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "大造じいさんとがん" },
    props: {
      unitTitle: unit_titles[27].title,
      learningUnitJson: LearningUnit28,
    },

  },
  {
    path: "/2/",
    name: "2",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう６" },
    props: {
      unitTitle: unit_titles[28].title,
      learningUnitJson: LearningUnit29,
    },

  },
  {
    path: "/3/",
    name: "3",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "心情を表す言葉" },
    props: {
      unitTitle: unit_titles[29].title,
      learningUnitJson: LearningUnit30,
    },

  },
  {
    path: "/4/",
    name: "4",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "日本語と外国語" },
    props: {
      unitTitle: unit_titles[30].title,
      learningUnitJson: LearningUnit31,
    },

  },
  {
    path: "/5/",
    name: "5",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "読書の世界を広げよう" },
    props: {
      unitTitle: unit_titles[31].title,
      learningUnitJson: LearningUnit32,
    },

  },
  {
    path: "/6/",
    name: "6",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう７" },
    props: {
      unitTitle: unit_titles[32].title,
      learningUnitJson: LearningUnit33,
    },

  },
  {
    path: "/7/",
    name: "7",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "いにしえの人のえがく世界" },
    props: {
      unitTitle: unit_titles[33].title,
      learningUnitJson: LearningUnit34,
    },

  },
  {
    path: "/8/",
    name: "8",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "「弱いロボット」だからできること" },
    props: {
      unitTitle: unit_titles[34].title,
      learningUnitJson: LearningUnit35,
    },

  },
  {
    path: "/9/",
    name: "9",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう８" },
    props: {
      unitTitle: unit_titles[35].title,
      learningUnitJson: LearningUnit36,
    },

  },
  {
    path: "/10/",
    name: "10",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "どう考える？　もしもの技術" },
    props: {
      unitTitle: unit_titles[36].title,
      learningUnitJson: LearningUnit37,
    },

  },
  {
    path: "/11/",
    name: "11",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "方言と共通語" },
    props: {
      unitTitle: unit_titles[37].title,
      learningUnitJson: LearningUnit38,
    },

  },
  {
    path: "/12/",
    name: "12",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "資料を見て考えたことを話そう" },
    props: {
      unitTitle: unit_titles[38].title,
      learningUnitJson: LearningUnit39,
    },

  },
  {
    path: "/13/",
    name: "13",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう９" },
    props: {
      unitTitle: unit_titles[39].title,
      learningUnitJson: LearningUnit40,
    },

  },
  {
    path: "/14/",
    name: "14",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "手塚治虫" },
    props: {
      unitTitle: unit_titles[40].title,
      learningUnitJson: LearningUnit41,
    },

  },
  {
    path: "/15/",
    name: "15",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢字を使おう10" },
    props: {
      unitTitle: unit_titles[41].title,
      learningUnitJson: LearningUnit42,
    },

  },
  {
    path: "/16/",
    name: "16",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "わたしの文章見本帳" },
    props: {
      unitTitle: unit_titles[42].title,
      learningUnitJson: LearningUnit43,
    },

  },
  {
    path: "/17/",
    name: "17",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "付録" },
    props: {
      unitTitle: unit_titles[43].title,
      learningUnitJson: LearningUnit44,
    },

  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
